//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBody.js";
import "../no/SelectBodyList.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/SelectEdge.js";
import "../no/SelectFace.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BlendRadius",1,0],[0,"BottomPlateClearance",1,0],[0,"CircDeleteAllComponents",1,0],[1,"CircularInsert",0,"SelectBody",0],[0,"CircularOperation",1,0],[0,"CircularVector",1,"Direction",0],[0,"ClearanceValue",1,0],[0,"ControlPoint",1,"Point",0],[1,"CopySelectInsert",0,"SelectBodyList",0],[1,"CreateCurvesToDivideFace",0,"Section",0],[0,"DesignTool",1,0],[0,"DestinationPoint",1,"Point",0],[1,"FaceForRamp",0,"ScCollector",0],[1,"FalseBodyHeight",0,"Expression",0],[0,"HeelFalseHeightClearance",1,0],[0,"HeelHeight",1,0],[0,"HeelLength",1,0],[0,"HeelRadian",1,0],[0,"HeelTypes",1,0],[0,"HeelWidth",1,0],[1,"InsertEdge",0,"SelectEdge",0],[1,"InsertShankFace",0,"ScCollector",0],[1,"InsertsToDelete",0,"SelectBodyList",0],[1,"MountPunchEdge",0,"SelectEdge",0],[1,"MountPunchFace",0,"ScCollector",0],[0,"OffsetAngle",1,0],[0,"OffsetX",1,0],[0,"OffsetY",1,0],[0,"PointForRamp",1,"Point",0],[1,"Punch",0,"SelectBody",0],[1,"PunchEdge",0,"SelectEdge",0],[0,"PunchPlateClearance",1,0],[1,"PunchShankFace",0,"ScCollector",0],[0,"PunchShankParaC",1,0],[0,"PunchShankParaFL",1,0],[0,"PunchShankParaL1",1,0],[0,"PunchShankParaLength",1,0],[0,"PunchShankParaPL",1,0],[0,"PunchShankParaR",1,0],[0,"PunchShankParaWidth",1,0],[1,"RadiusForRamp",0,"Expression",0],[1,"RampShankHeight",0,"Expression",0],[0,"RampSteps",1,0],[0,"RectDeleteAllComponents",1,0],[1,"RectangularInsert",0,"SelectBody",0],[0,"RectangularOperation",1,0],[0,"RectangularXVector",1,"Direction",0],[0,"RectangularYVector",1,"Direction",0],[1,"SelectFaceToDivide",0,"SelectFace",0],[1,"SelectInsertToDeleteRamp",0,"SelectBody",0],[1,"SelectRampFeature",0,"SelectNXObjectList",0],[1,"SelectShankProfile",0,"Section",0],[0,"ShankShape",1,0],[1,"ShanksToDelete",0,"ScCollector",0],[1,"SketchToRevolve",0,"Section",0],[0,"StripperPlateClearance",1,0],[0,"TotalAlongX",1,0],[0,"TotalAlongY",1,0],[0,"TotalNumber",1,0],[0,"Type",1,0],[0,"UseBottomPlateClearance",1,0],[0,"UseClearance",1,0],[0,"UseFaceOrSketch",1,0],[0,"UsePunchPlateClearance",1,0],[0,"UseStripperPlateClearance",1,0],[0,"VectorForRamp",1,"Direction",0]],[[[],"DesignMountHead",{},0,0]],[]];
SPLM.Tooling.InsertAuxiliaryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.InsertAuxiliaryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.InsertAuxiliaryBuilder.Types = Object.freeze({
    "InsertFlange" : "InsertFlange", "InsertRamp" : "InsertRamp", "InsertHeel" : "InsertHeel", "PunchMount" : "PunchMount", "Tools" : "Tools"});

SPLM.Tooling.InsertAuxiliaryBuilder.ShankShapeTypes = Object.freeze({
    "Flange" : "Flange", "Ramp" : "Ramp", "Heel" : "Heel"});

SPLM.Tooling.InsertAuxiliaryBuilder.RampStepsType = Object.freeze({
    "AddMaterial" : "AddMaterial", "CreateCurvesAndDivideFace" : "CreateCurvesAndDivideFace", "CreateRamp" : "CreateRamp", "DeleteRamp" : "DeleteRamp"});

SPLM.Tooling.InsertAuxiliaryBuilder.HeelTypesType = Object.freeze({
    "RType" : "RType", "CType" : "CType"});

SPLM.Tooling.InsertAuxiliaryBuilder.UseFaceOrSketchToRevolve = Object.freeze({
    "Face" : "Face", "Sketch" : "Sketch"});

SPLM.Tooling.InsertAuxiliaryBuilder.DesignToolOption = Object.freeze({
    "Copy" : "Copy", "Array" : "Array", "Delete" : "Delete"});

SPLM.Tooling.InsertAuxiliaryBuilder.RectOperationOption = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "Delete" : "Delete"});

SPLM.Tooling.InsertAuxiliaryBuilder.CircOperationTypes = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "Delete" : "Delete"});

export default SPLM;